import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { WordMark } from "@/components/brand";
import { POOL_NIGHT } from "@/constants/media";
import AuthNav from "@/components/site/AuthNav";

const inputCls = "w-full bg-black/40 border border-white/10 rounded-md px-3 py-2.5 text-sm text-foreground focus:border-gold focus:outline-none";

export default function StaffInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/staff-invite/${token}`).then((r) => setInfo(r.data)).catch((e) => { setInfo(false); toast.error(apiErr(e)); });
  }, [token]);

  const accept = async () => {
    setSaving(true);
    try {
      await api.post(`/staff-invite/${token}/accept`, { password: pw });
      toast.success("Account ready. Please sign in.");
      nav("/login");
    } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="staff-invite">
      <AuthNav />
      <div className="relative hidden lg:block">
        <img src={POOL_NIGHT} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="relative z-10 h-full flex items-end p-12">
          <p className="font-serif text-3xl italic text-gold text-glow-gold max-w-sm">Welcome to the team at The D.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-ink pt-24 lg:pt-8">
        <div className="w-full max-w-sm">
          <WordMark className="mb-6" />
          {info === null ? <p className="text-sm text-muted-foreground">Loading invitation…</p>
            : info === false ? <p className="text-sm text-red-300">This invitation is no longer valid. Please contact your manager.</p>
            : (
              <>
                <h1 className="font-serif text-3xl">Set up your account</h1>
                <p className="text-sm text-muted-foreground mt-1 mb-6">
                  <span className="text-foreground">{info.email}</span> · Role: <span className="text-gold">{info.role_label}</span>
                </p>
                <input type="password" className={inputCls} placeholder="Create a password (8+ chars, upper/lower/number)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="staff-invite-password" />
                <button onClick={accept} disabled={saving || !pw} className="btn-gold w-full py-3 text-sm mt-4 flex items-center justify-center gap-2" data-testid="staff-invite-accept">
                  {saving ? <Loader2 className="animate-spin" size={15} /> : <ShieldCheck size={15} />} Activate My Account
                </button>
                <p className="text-[11px] text-muted-foreground/70 text-center mt-4">Your access is limited to the {info.role_label} role.</p>
              </>
            )}
        </div>
      </div>
    </div>
  );
}
